import { render, staticRenderFns } from "./wechatForm.vue?vue&type=template&id=1d5e289b&scoped=true&"
import script from "./wechatForm.vue?vue&type=script&lang=js&"
export * from "./wechatForm.vue?vue&type=script&lang=js&"
import style0 from "./wechatForm.vue?vue&type=style&index=0&id=1d5e289b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e289b",
  null
  
)

export default component.exports